import React from "react"

import "./block.scss"
import "./videoBlock.scss"

const VideoBlock = ({ video, poster, children }) => {
  return (
    <section className="section section-padding inverse">
      <div className="centre">
        <div className="video-block">
          <div>
            <video controls poster={poster}>
              <track kind="captions" srcLang="en" label="english_captions" />
              <source src={video} type="video/mp4" />
              Your browser does not support HTML5 video.
            </video>
          </div>
          <div>{children}</div>
        </div>
      </div>
    </section>
  )
}

export default VideoBlock
